export { default as ListView } from 'depreciations/components/DepreciationsListView';
export { default as FormView } from 'depreciations/components/DepreciationFormView';
export { default as Row } from 'depreciations/components/list/DepreciationsListRow';



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/components/index.js